
        <div class="luxury-viewer-backdrop fixed inset-0 z-[100000] flex items-center justify-center bg-black/60 backdrop-blur p-3 sm:p-6" (click)="close()">
            <div
                class="relative flex h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-3xl border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)] shadow-2xl"
                (click)="$event.stopPropagation()"
                role="dialog"
                aria-modal="true"
                [attr.aria-label]="title || 'Image viewer'"
            >
                <div class="sticky top-0 z-10 border-b border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)]/90 px-4 py-3 backdrop-blur">
                    <div class="flex items-center gap-3">
                        <div class="min-w-0 flex-1">
                            <p class="truncate text-sm font-semibold text-[color:var(--foreground)]">
                                {{ title || 'Photos' }}
                                <span class="ml-2 text-xs font-semibold text-[color:var(--muted-foreground)]">
                                    {{ safeIndex + 1 }} / {{ images.length }}
                                </span>
                            </p>
                        </div>

                        <div class="flex items-center gap-1">
                            <button
                                type="button"
                                class="inline-flex items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)] p-2 text-[color:var(--foreground,#0f172a)] transition hover:bg-[color:var(--hover,#f1f5f9)] disabled:opacity-40"
                                (click)="zoomOut()"
                                [disabled]="zoom <= 1"
                                aria-label="Zoom out"
                            >
                                <lucide-icon name="minus" class="h-4 w-4"></lucide-icon>
                            </button>
                            <button
                                type="button"
                                class="inline-flex items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)] p-2 text-[color:var(--foreground,#0f172a)] transition hover:bg-[color:var(--hover,#f1f5f9)] disabled:opacity-40"
                                (click)="resetZoom()"
                                [disabled]="zoom === 1 && translateX === 0 && translateY === 0"
                                aria-label="Reset zoom"
                            >
                                <lucide-icon name="maximize-2" class="h-4 w-4"></lucide-icon>
                            </button>
                            <button
                                type="button"
                                class="inline-flex items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)] p-2 text-[color:var(--foreground,#0f172a)] transition hover:bg-[color:var(--hover,#f1f5f9)] disabled:opacity-40"
                                (click)="zoomIn()"
                                [disabled]="zoom >= maxZoom"
                                aria-label="Zoom in"
                            >
                                <lucide-icon name="plus" class="h-4 w-4"></lucide-icon>
                            </button>
                        </div>

                        <button
                            type="button"
                            class="inline-flex items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)] p-2 text-[color:var(--foreground,#0f172a)] transition hover:bg-[color:var(--hover,#f1f5f9)]"
                            (click)="close($event)"
                            aria-label="Close"
                        >
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>
                </div>

                <div class="relative flex-1 min-h-0 bg-[color:var(--background,#fff)]">
                    <button
                        type="button"
                        class="absolute left-3 top-1/2 z-10 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)]/90 text-[color:var(--foreground,#0f172a)] shadow-lg backdrop-blur transition hover:bg-[color:var(--hover,#f1f5f9)] disabled:opacity-40"
                        (click)="prev()"
                        [disabled]="images.length < 2"
                        aria-label="Previous"
                    >
                        <lucide-icon name="chevron-left" class="h-5 w-5"></lucide-icon>
                    </button>

                    <button
                        type="button"
                        class="absolute right-3 top-1/2 z-10 -translate-y-1/2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)]/90 text-[color:var(--foreground,#0f172a)] shadow-lg backdrop-blur transition hover:bg-[color:var(--hover,#f1f5f9)] disabled:opacity-40"
                        (click)="next()"
                        [disabled]="images.length < 2"
                        aria-label="Next"
                    >
                        <lucide-icon name="chevron-right" class="h-5 w-5"></lucide-icon>
                    </button>

                    <div
                        class="relative flex h-full w-full items-center justify-center overflow-hidden"
                        [ngClass]="zoom > 1 ? (dragging ? 'cursor-grabbing' : 'cursor-grab') : 'cursor-default'"
                        (wheel)="onWheel($event)"
                        (dblclick)="toggleZoom($event)"
                        (pointerdown)="onPointerDown($event)"
                        (pointermove)="onPointerMove($event)"
                        (pointerup)="onPointerUp($event)"
                        (pointercancel)="onPointerCancel()"
                    >
                        <ng-container *ngIf="currentUrl; else emptyState">
                            <img
                                [src]="currentUrl"
                                [alt]="currentAlt || title || 'Image'"
                                class="block h-full w-full select-none object-contain will-change-transform"
                                [style.transform]="imageTransform"
                                [style.transition]="dragging ? 'none' : 'transform 220ms ease'"
                                decoding="async"
                                loading="eager"
                                (load)="onImageLoaded($event)"
                                (error)="onImageFailed($event)"
                            />
                        </ng-container>

                        <ng-template #emptyState>
                            <div class="flex flex-col items-center justify-center gap-2 text-[color:var(--muted-foreground)]">
                                <lucide-icon name="image" class="h-14 w-14 opacity-50"></lucide-icon>
                                <p class="text-sm font-semibold">Image unavailable</p>
                            </div>
                        </ng-template>

                        <div
                            *ngIf="loading"
                            class="pointer-events-none absolute inset-0 flex items-center justify-center bg-[color:var(--background,#fff)]/40"
                        >
                            <div class="flex items-center gap-2 rounded-full bg-[color:var(--card,#fff)]/90 px-4 py-2 text-sm font-semibold text-[color:var(--foreground,#0f172a)] shadow-lg backdrop-blur">
                                <lucide-icon name="loader-2" class="h-5 w-5 animate-spin"></lucide-icon>
                                Loading…
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="images.length > 1" class="border-t border-[color:var(--border,#e2e8f0)] bg-[color:var(--card,#fff)]/90 p-3 backdrop-blur">
                    <div class="flex gap-2 overflow-x-auto pb-1">
                        <button
                            *ngFor="let img of images; let idx = index"
                            type="button"
                            (click)="goTo(idx)"
                            class="relative h-14 w-20 sm:h-16 sm:w-24 flex-shrink-0 overflow-hidden rounded-lg border transition"
                            [ngClass]="idx === safeIndex ? 'border-[color:var(--primary)] ring-2 ring-[color:var(--primary)]/40' : 'border-[color:var(--border,#e2e8f0)] hover:border-[color:var(--muted-foreground,#94a3b8)]/40'"
                        >
                            <img
                                [src]="resolveThumb(img) || ''"
                                [alt]="img.alt || 'Thumbnail'"
                                class="block h-full w-full object-cover"
                                decoding="async"
                                loading="lazy"
                                (error)="markThumbError(img)"
                            />
                            <span *ngIf="img.isMain" class="absolute bottom-1 left-1 rounded bg-black/60 px-2 py-0.5 text-[10px] text-white">Main</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
